export default __webpack_public_path__ + "static/media/benefits-landing-preview-desktop-v4.ffec26d8.png";